/**
 * Content carousel (slider) with extensive options to control behaviour and appearance
 * @requires https://swiperjs.com/
 */

import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

// Register Swiper modules
Swiper.use([Navigation]);

export default (() => {
  // Get all elements with the 'swiper' class or data-swiper attribute
  const carousels = document.querySelectorAll("[data-swiper]");
  if (carousels.length === 0) return;

  // Iterate over each element
  carousels.forEach((element) => {
    let options = {};

    // Parse swiper options from the data attribute
    if (element.dataset.swiper !== undefined && element.dataset.swiper !== "") {
      try {
        options = JSON.parse(element.dataset.swiper);
      } catch (e) {
        console.error("Error parsing Swiper options:", e);
        return;
      }
    }

    // Create a new Swiper instance
    const swiper = new Swiper(element, options);

    // Check if a controlled slider is specified
    if (options.controlSlider) {
      let controlledSliders = [];
      if (Array.isArray(options.controlSlider)) {
        // Handle multiple sliders
        controlledSliders = options.controlSlider.map((selector) =>
          document.querySelector(selector),
        );
      } else {
        // Handle single slider
        controlledSliders.push(document.querySelector(options.controlSlider));
      }
      const swiperControlledInstances = controlledSliders
        .filter((slider) => slider !== null)
        .map((controlledSlider) => {
          const controlledSliderOptions =
            controlledSlider.dataset.swiper &&
            JSON.parse(controlledSlider.dataset.swiper);

          // Create a new Swiper instance for each controlled slider
          return new Swiper(controlledSlider, controlledSliderOptions);
        });
      swiper.controller.control = swiperControlledInstances;
    }
  });
})();
